import { render, staticRenderFns } from "./examPhotoQuery.vue?vue&type=template&id=447f7a52&scoped=true&"
import script from "./examPhotoQuery.vue?vue&type=script&lang=js&"
export * from "./examPhotoQuery.vue?vue&type=script&lang=js&"
import style0 from "./examPhotoQuery.vue?vue&type=style&index=0&id=447f7a52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f7a52",
  null
  
)

export default component.exports